import React, { Component } from 'react';
import styles from './Grid.module.css';
import Swatch from '../Swatch';
import { forceCheck } from 'react-lazyload';
import Waypoint from 'react-waypoint';

export default class Grid extends Component {
  navTo = item => {
    const { navTo, catogary } = this.props;
    navTo(item._id, catogary);
  };

  componentDidUpdate(oldProps) {
    const { tag } = this.props;
    if (oldProps.tag !== tag) {
      forceCheck();
    }
  }

  render() {
    const {
      items,
      active,
      tag,
      onSelect,
      selected,
      onLeave,
      catogary,
      createJob,
    } = this.props;
    const keys = Object.keys(items);
    return (
      <div className={styles.container}>
        {keys
          .filter(id => {
            if (!items[id].tags) return false;
            if (tag && items[id].tags.indexOf(tag) === -1) return false;
            return true;
          })
          .map((id, k) => {
            const pageCursor = k / 23;
            const imgUrl = items[id].thumbnail || `/img/noimage.png`;
            if (k % 23 === 0) {
              return (
                <div className={styles.swatchContainer} key={id}>
                  <Waypoint
                    key={pageCursor}
                    onLeave={e => onLeave && onLeave(pageCursor)}
                  />
                  <Swatch
                    createJob={createJob}
                    item={items[id]}
                    image={imgUrl}
                    onSelect={onSelect}
                    selected={selected && selected[id]}
                    onClick={e => this.navTo(items[id])}
                    active={!active && id === active}
                    catogary={catogary}
                  />
                </div>
              );
            } else {
              return (
                <div className={styles.swatchContainer} key={id}>
                  <Swatch
                    createJob={createJob}
                    item={items[id]}
                    image={imgUrl}
                    onSelect={onSelect}
                    selected={selected && selected[id]}
                    onClick={e => this.navTo(items[id])}
                    active={!active && id === active}
                    catogary={catogary}
                  />
                </div>
              );
            }
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/index.js